































































































import { Vue, Component } from "vue-property-decorator"
import STitleLarge from "@/components/STitleLarge"
import SNavigateBox from "@/components/SNavigateBox"
import SInfoBox from "@/components/SInfoBox"
import SSearchBox from "@/components/SSearchBox"
import SStatusBox from "@/components/SStatusBox"
import SCustomerForm from "@/components/SCustomerForm"
import SCustomerSearchForm from "@/components/SCustomerSearchForm"
import { Debounce, Bind } from "lodash-decorators"
import {
    GET_DASHBOARD_TOTAL_VENUE,
    GET_DASHBOARD_TOTAL_BOX,
    GET_DASHBOARD_TOTAL_ONLINE_BOX,
    GET_DASHBOARD_TOTAL_OFFLINE_BOX,
    GET_DASHBOARD_TOTAL_UPDATE_REQUIRED_BOX,
} from "@/store/types/getters"
import { Getter } from "vuex-class"

@Component({
    components: {
        STitleLarge,
        SNavigateBox,
        SInfoBox,
        SSearchBox,
        SStatusBox,
        SCustomerForm,
        SCustomerSearchForm,
    },
})
export default class Dashboard extends Vue {
    private search: string | null = null

    @Getter(GET_DASHBOARD_TOTAL_VENUE)
    dashboardTotalVenue!: number
    @Getter(GET_DASHBOARD_TOTAL_BOX) dashboardTotalBox!: number
    @Getter(GET_DASHBOARD_TOTAL_ONLINE_BOX)
    dashboardTotalOnlineBox!: number
    @Getter(GET_DASHBOARD_TOTAL_OFFLINE_BOX)
    dashboardTotalOfflineBox!: number
    @Getter(GET_DASHBOARD_TOTAL_UPDATE_REQUIRED_BOX)
    dashboardTotalUpdateRequiredBox!: number

    @Debounce(700)
    @Bind
    private onAdd() {
        const options = {
            name: "SCustomerForm",
            height: "auto",
            draggable: true,
        }

        this.$modal.show(SCustomerForm, undefined, options)
    }

    @Debounce(700)
    @Bind
    private onSearch() {
        const options = {
            name: "SCustomerSearchForm",
            height: "auto",
            draggable: true,
        }

        this.$modal.show(SCustomerSearchForm, undefined, options)
    }
}
